import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router'
import { APPLICATION_MODE_NEW, APPLICATION_MODE_RENEW, APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE, APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE, APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE, RJSC_PAGE_LINK, ROUTE_PATH } from '../../app/constants'
import { rjscSearchSelect } from '../../redux/selector/rjscSearchSelector'
import {
    setRjscSearchString,
    setRjscSearchStringType,
    fetchRjscDetails,
    setRjscSearchStatus,
    // fetchRjscFromNumberAndSetDetails,
    setRjscAdvanceSearchString,
    setRjscAdvanceSearchResponse
} from '../../redux/slice/rjscSearchSlice'

import {
    Header,
    Paragraph,
    Button,
    NavigationLinkButton,
    // BackButton
} from '../../components/RegularComponents'
import { REQUEST_STATUS } from '../../app/constants';
import { replaceUrlParams } from '../../app/utils';
import Navigation from '../Navigation';
import { ERROR_STRING } from '../../app/errors';
import { isMortgageTypeApplication } from '../../redux/slice/applicationsUtils';
import TopNavigationBar from '../TopNavigationBar';

/*
 * This component will allow user to enter a string and search for the company details.
 * component will take care of navigating to the next screen in case of successful search result.
 * 
 * Flow : 
 *   - searchStatus prop will control the flow of the screen to the next screen. 
 *   - Flow 1 : idle -> data-received -> success -> switch to next view -> idle 
 *   - Flow 2 : idle -> data-received -> error -> show error 
 *   - Flow 3 : (only for testing) : idle -> dummy-data-received -> success -> switch to next view -> idle
 * 
 *   Flow 1 & 2 are for the actual success and failure scenarios. 
 *   Flow 3 is only for testing where dummy data will be shown. Turn on the flag "SHOW_DUMMY_RESPONSE" in the rjscSearchSlice.js for this flow to be effective.
 * 
 *   There are two options for the next view. 1) show list of search results 2) show company details to confirm. 
 *   - the list of search results is shown when there are multiple search results found in the response.
 *   - the company details view is shown when response contains only one response. 
 *   - the switching happens automatically based on the response received.
 *   
 */
const RJSCSearch = (props) => {
    const { rjscSearch, dispatch } = props
    const { applicationType, applicationMode } = props.match.params
    const { searchStatus } = rjscSearch
    const [rjscNumberText, setRjscNumberText] = useState("")
    const [rjscNameText, setRjscNameText] = useState("")

    const [showNoStringError, setShowNoStringError] = useState(false)
    const [showNoResultError, setShowNoResultError] = useState(false)

    const resetErrorStatus = () => {
        if (showNoResultError) {
            setShowNoResultError(false)
        }

        if (showNoStringError) {
            setShowNoStringError(false)
        }
    }

    const onRjscNumberTextChange = (e) => {
        setRjscNumberText(e.target.value)
        resetErrorStatus()
    }

    const onRjscNameTextChange = (e) => {
        setRjscNameText(e.target.value)
        resetErrorStatus()
    }

    useEffect(() => {
        if (searchStatus === REQUEST_STATUS.SUCCESS) {
            if (rjscSearch.searchResponseData &&
                Array.isArray(rjscSearch.searchResponseData) &&
                rjscSearch.searchResponseData.length > 0) {

                if (rjscNumberText && rjscSearch.searchResponseData.length === 1) {

                    // The response contains only the basic information. 
                    // Fetch the complete response for the given registry number and then 
                    // move to the next screen.

                    const resp = rjscSearch.searchResponseData[0]
                    const { registryNumber } = resp

                    dispatch(setRjscAdvanceSearchString({ searchText: registryNumber }))
                    dispatch(setRjscAdvanceSearchResponse(rjscSearch.searchResponseData))
                    dispatch(push(replaceUrlParams(
                        ROUTE_PATH.RJSC_OPERATING_NAME_SEARCH_SELECT,
                        applicationType,
                        applicationMode)
                    )
                    )
                    // dispatch(fetchRjscFromNumberAndSetDetails(registryNumber))
                    //         .then(data => {
                    //             dispatch(push(replaceUrlParams(
                    //                 ROUTE_PATH.RJSC_DETAIL_REVIEW, 
                    //                 applicationType, 
                    //                 applicationMode)))
                    //             dispatch(setRjscSearchStatus("idle"))
                    //         })
                } else {
                    dispatch(push(replaceUrlParams(
                        ROUTE_PATH.RJSC_SEARCH_SELECT,
                        applicationType,
                        applicationMode)))
                    dispatch(setRjscSearchStatus("idle"))
                }
            } else if (!rjscSearch.searchResponseData ||
                (Array.isArray(rjscSearch.searchResponseData) &&
                    rjscSearch.searchResponseData.length === 0)) {
                setShowNoResultError(true)
            }
        }
    }, [searchStatus,
        rjscSearch.searchResponseData,
        dispatch,
        applicationType,
        applicationMode,
        rjscNumberText])
    /*
     * search click handler. 
     * The function sets the search string to the store and invokes an API request to search the string.
     * The response handler will check the response and automatically navigate to the detail preview screen. 
     */
    const onSearchClick = (e) => {
        // fetch the search result & navigate to the next screen after handilng all scenarios
        let searchString = ''

        if (rjscNameText) {
            dispatch(setRjscSearchStringType({ searchType: "rjscSearchName" }))
            searchString = rjscNameText
        } else if (rjscNumberText) {
            dispatch(setRjscSearchStringType({ searchType: "rjscSearchNumber" }))
            searchString = rjscNumberText
        } else {
            // show error
            setShowNoStringError(true)
            return
        }

        dispatch(setRjscSearchString({ searchText: searchString }))
        dispatch(fetchRjscDetails(searchString))
    }

    const isShowError = () => {
        return (
            searchStatus === REQUEST_STATUS.ERROR
            || showNoResultError
            || showNoStringError
        )
    }
    let formControlClass = "row form-group"

    // // below class will paint all components red
    // if(searchStatus === REQUEST_STATUS.ERROR)
    //     formControlClass += " has-error"

    const showBackNavigation = (applicationMode === APPLICATION_MODE_RENEW
        && (isMortgageTypeApplication(applicationType)
            || applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE
            || applicationType === APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE));

    const handleNBExemptClick = () => {
        dispatch(push(replaceUrlParams(
            ROUTE_PATH.RJSC_COMPANY_DETAIL,
            applicationType,
            applicationMode)
        ))
    }

    return (
        <>
            <Navigation {...props} />
            <div className={"container"}>
                {showBackNavigation && (
                    <TopNavigationBar
                        {...props}
                        applicationType={applicationType}
                        applicationMode={APPLICATION_MODE_NEW}
                        hideSaveAndExit={false}
                    />
                )}
                {/* <div className="row topMarginNormal">
                <BackButton onClick={() => {props.history.goBack()}} />
            </div> */}
                <div className="row">
                    <div className="col-lg-8">
                        <Header id="rjsc-search-header" header={rjscSearch.header} />
                        <Paragraph id="rjsc-search-text" text={rjscSearch.text} />
                    </div>
                </div>
                <div className={formControlClass}>
                    <div className="col-lg-8">
                        <div className={"form-group" + (showNoStringError ? " has-error" : "")}>
                            <label
                                id="rjsc-search-name-label"
                                className="control-label"
                                htmlFor="rjsc-name-text"
                            >
                                {rjscSearch.inputHeaderRjscNameSearch}
                            </label>
                            <input
                                id="rjsc-name-text"
                                nameid="rjsc-name-text"
                                className="form-control ns-input fw-20"
                                type="text"
                                value={rjscNameText}
                                onInput={onRjscNameTextChange}
                                style={{ display: "inline" }}
                            />
                            {showNoStringError && (
                                <span style={{ marginLeft: "5px" }}>
                                    <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                                </span>
                            )}
                        </div>

                        <div className={"topMarginNormal bottomMarginNormal"}>{"Or"}</div>

                        <div className={"form-group" + (showNoStringError ? " has-error" : "")}>
                            <label
                                id="rjsc-search-number-label"
                                className="control-label"
                                htmlFor="rjsc-number-text"
                            >
                                {rjscSearch.inputHeaderRjscNumberSearch}
                            </label>
                            <div className="help-block bottomMarginNormal">
                                Find your RJSC number by{" "}
                                <a href={RJSC_PAGE_LINK} target="blank">
                                    searching here
                                </a>
                            </div>
                            <input
                                id="rjsc-number-text"
                                name="rjsc-number-text"
                                className="form-control ns-input fw-20"
                                type="text"
                                value={rjscNumberText}
                                onInput={onRjscNumberTextChange}
                                style={{ display: "inline" }}
                            />
                            {showNoStringError && (
                                <span style={{ marginLeft: "5px" }}>
                                    <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                                </span>
                            )}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-2 topMarginNormal">
                        <div className="has-error">
                            <div className="help-block">
                                <Button
                                    id="rjsc-search-button"
                                    text={"Next"}
                                    showSpinner={searchStatus === REQUEST_STATUS.IN_PROGRESS}
                                    buttonType={"regular_primary"}
                                    onClick={onSearchClick}
                                />
                                {isShowError() && (
                                    <span style={{ marginLeft: "5px" }}>
                                        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                    {(applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE ||
                        applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE ||
                        applicationType === APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE) &&
                        applicationMode === APPLICATION_MODE_RENEW ? null : (
                        <div className="col-lg-6 topMarginNormal">
                            <NavigationLinkButton
                                text={"My company is exempt and doesn't have an RJSC number"}
                                onClick={handleNBExemptClick}
                                buttonType={"regular_link"}
                            />
                        </div>
                    )}
                </div>
                {showNoStringError && (
                    <div className="row">
                        <div className="col-lg-12 topMarginNormal">
                            <div className="has-error">{ERROR_STRING.RJSC_SEARCH_NO_STRING}</div>
                        </div>
                    </div>
                )}
                {showNoResultError && (
                    <div className="row">
                        <div className="col-lg-12 topMarginNormal">
                            <div className="has-error">{ERROR_STRING.RJSC_SEARCH_NO_RESULT}</div>
                        </div>
                    </div>
                )}
                {searchStatus === REQUEST_STATUS.ERROR && (
                    <div className="row">
                        <div className="col-lg-12 topMarginNormal">
                            <div className="has-error">{ERROR_STRING.RJSC_SEARCH_REQUEST_FAILED}</div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default connect(rjscSearchSelect)(RJSCSearch)
